module.exports = __webpack_public_path__ + "img/afrochampions.b7476d23.png";